export type WebsiteFaqItem = {
  question: string;
  answer: string;
};

export const WEBSITE_BIALYSTOK_FAQ = [
  {
    question: 'Ile kosztuje stworzenie strony internetowej w Waszej agencji?',
    answer: 'Ceny prostych stron typu landing page lub wizytówek zaczynają się u nas od 1500 zł netto. Rozbudowane serwisy firmowe z indywidualnym designem to zazwyczaj inwestycja od 3000 zł netto. Każdy projekt wyceniamy indywidualnie na podstawie wymagań technicznych. Najszybszym sposobem na poznanie kosztów jest wypełnienie naszego krótkiego briefu – na jego podstawie przygotujemy niezobowiązującą wycenę.',
  },
  {
    question: 'Czy działacie tylko na terenie Białegostoku, czy w całej Polsce?',
    answer: 'Choć sercem naszej agencji jest Białystok i tu najczęściej spotykamy się z klientami na kawę, pracujemy w pełni zdalnie z firmami z całej Polski i zagranicy. Nasz proces projektowy mamy zoptymalizowany pod kątem komunikacji online, co pozwala nam na płynną i transparentną współpracę niezależnie od tego, skąd prowadzisz biznes.',
  },
  {
    question: 'Ile czasu zajmuje realizacja projektu?',
    answer: 'Prostsze strony internetowe oddajemy zazwyczaj w 2 do 4 tygodni. Bardziej zaawansowane serwisy, wymagające dedykowanego projektowania UI/UX i niestandardowych integracji, zajmują więcej czasu (do kilku/kilkunastu tygodniu w zalezności od stopnia skomplikowania).',
  },
  {
    question: 'Czy po wdrożeniu strony oferujecie wsparcie techniczne i SEO?',
    answer: 'Oczywiście. Oddajemy w Twoje ręce gotowy, szybki i zoptymalizowany pod wyszukiwarki produkt. Oferujemy również dodatkowe, płatne pakiety opieki – w ich ramach zapewniamy stałe wsparcie techniczne, dbamy o bezpieczeństwo serwisu i pomagamy w dalszym skalowaniu poprzez pozycjonowanie i działania marketingowe, aby strona stale rosła.',
  },

];
